import { render } from "./HomeMyDataUpdate.vue?vue&type=template&id=157c43d9"
import script from "./HomeMyDataUpdate.vue?vue&type=script&lang=js"
export * from "./HomeMyDataUpdate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__